function d() {
  var r;
  return {
    before: function before(_ref) {
      var e = _ref.doc;
      var l;
      var o = e.documentElement,
        t = (l = e.defaultView) != null ? l : window;
      r = Math.max(0, t.innerWidth - o.clientWidth);
    },
    after: function after(_ref2) {
      var e = _ref2.doc,
        o = _ref2.d;
      var t = e.documentElement,
        l = Math.max(0, t.clientWidth - t.offsetWidth),
        n = Math.max(0, r - l);
      o.style(t, "paddingRight", "".concat(n, "px"));
    }
  };
}
export { d as adjustScrollbarPadding };